import { ReactNode, useEffect } from "react";
import { Button, Typography } from "mobily-ui-library/lib";

import "./ErrorModal.scss";

interface Props {
  id: string;
  rtl: boolean;
  title: string;
  description: string;
  firstButtonText: string;
  secButtonText?: string;
  modalFirstButtonClick: () => void;
  modalSecondButtonClick?: () => void;
  onClickClose?: () => void;
  idCloseIcon?: string;
  ConfirmModalClose?: string;
  showCloseIcon?: boolean;
  children?: ReactNode;
}

function ErrorModal({
  id,
  rtl,
  title,
  description,
  firstButtonText,
  secButtonText,
  idCloseIcon,
  ConfirmModalClose,
  showCloseIcon = false,
  children,
  modalFirstButtonClick,
  modalSecondButtonClick,
  onClickClose,
}: Props) {
  // useEffect(() => {
  //   document.body.style.overflow = "hidden";
  // }, []);
  // window.scroll({ top: 0, left: 0 });
  const Rtl = rtl ? "right" : "left";
  return (
    <div
      className={
        rtl
          ? "Error__ModalContainer Error__ModalRight"
          : "Error__ModalContainer"
      }
    >
      <div className="Error__Fallback"></div>
      <div className="Error__Modal" id={id}>
        {showCloseIcon && (
          <div
            id={idCloseIcon}
            onClick={onClickClose}
            className={`confirmModal-closeIcon-container-${Rtl}`}
          >
            <img src={ConfirmModalClose} alt="close" />
          </div>
        )}

        <Typography rtl={rtl} className="Error__MT">
          {title}
        </Typography>
        <Typography rtl={rtl} className="Error__MST">
          {description}
        </Typography>
        {children}
        <div className="Error_Button">
          <Button
            rtl={rtl}
            className="Error__MButton"
            onClick={modalFirstButtonClick}
          >
            {firstButtonText}
          </Button>
          {secButtonText && (
            <Button
              rtl={rtl}
              className="Error__MButton Error__SecButton"
              onClick={modalSecondButtonClick}
            >
              {secButtonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ErrorModal;
